import mockData from '@features/widget-series-table/fixtures/data-new.json';

export default function* generator() {
    yield mockData;
}
